var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bookmark"},[(_vm.isMenu)?_c('SMenuButton',{attrs:{"icon":_vm.icon,"text":_vm.$t(_vm.text)},on:{"click":_vm.bookmarkHandler}}):_c('SButton',{attrs:{"icon":_vm.icon,"text":_vm.$t(_vm.text),"color":"secondary","variant":"outlined","async-action":_vm.bookmarkHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }